import React, { useState } from 'react';
import { getConsent } from '../../services/apicall';
import { Statescontex } from '../../context';
import { Button, Typography } from "antd";
const { Text } = Typography;

const clientId = "309188169045-fk7d1hqogk3fbm3692fpognmj967171p.apps.googleusercontent.com";
const DhanIcon = require("../../devdata/icons/dhanLogo.png")

const DhanLogin = ({ from }: "Login" | "Signup") => {
    const [loading, setloading] = useState(false)
    const { setErrorMessage, setErrorshow } = Statescontex()
    const onSuccess = () => {
    };
    const handleClick = async () => {

        const consentID = await getConsent(setloading, setErrorMessage, setErrorshow)
        console.log(consentID);

        if (consentID) {
            console.log("Consent Redirection");
            sessionStorage.setItem("from", from)
            const url = `https://auth.dhan.co/consent-login?consentId=${consentID}`
            window.location.href = url
        }
    }
    return (
        <div id="signInButton" className="flex justify-center my-2">
            <button
                type="button"
                onClick={handleClick}
                className="flex items-center justify-center gap-2 rounded-full w-[188px] h-[39px] py-[1px] bg-[#202124] hover:bg-[#17875f]/25 focus:outline-none"
            >
                <img src={DhanIcon} alt="Dhan" className="w-10 h-full -ml-[17px] mr-[13px]" />
                <span className="text-[#e8eaed]" style={{ fontFamily: 'sans-serif' }}>
                    Sign in with Dhan
                </span>
            </button>
        </div>

    );
}

export default DhanLogin;
